var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadCsv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Upload Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Upload-Copy",
    stroke: "none",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "0 0 32 0 32 32 0 32"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(3.000000, 6.000000)",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,13.6842105 L26,17.1052632 C26,18.9946584 24.4683426,20.5263158 22.5789474,20.5263158 L3.42105263,20.5263158 C1.53165743,20.5263158 0,18.9946584 0,17.1052632 L0,13.6842105",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 16.4210526,
    x2: 13,
    y2: 0,
    id: "Path",
    transform: "translate(13.000000, 8.210526) scale(1, -1) translate(-13.000000, -8.210526) "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    transform: "translate(13.000000, 14.394737) scale(1, -1) translate(-13.000000, -14.394737) ",
    points: "17.4473684 16.7894737 13 12 8.55263158 16.7894737"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadCsv);
export default __webpack_public_path__ + "static/media/download-csv.72ff3102ba2b93e0c6ba548fb4c765d7.svg";
export { ForwardRef as ReactComponent };